import React, { useState } from "react";
import Header from "../../master/SideBar";
import Nav from "../../master/NavBar";
import Footer from "../footer";
import { useNavigate } from "react-router-dom";

const AllBatchkittransction = () => {
  const navigate = useNavigate();
  const [selectAll, setSelectAll] = useState(false);
  const [selectedStudents, setSelectedStudents] = useState([]);

  const students = [
    "BHAVYAM SANKHLA (2993)", "YATI JANGID (3413)", "VANSHIKA SHARMA (2946)", "TEJSHVI BARALA (3200)",
    "TANUJ CHOUDHARY (3429)", "SHYAM CHOUDHARY (2997)", "RISHANT YADAV (3352)", "KHUSHI SHARMA (2931)",
    "KHUSHI KUMAWAT (3412)", "HYANSH (3347)", "HITANSHI SHARMA (2901)", "DIVYANSHI (3156)",
    "BHAVYANSH JANGID (3345)", "BHAVYA KASANA (2913)", "ARYAN CHOUDHARY (3187)", "ANUSHKA CHOUDHARY (3358)",
    "ADITI CHOUDHARY (2908)", "YUVIKA BARALA (3164)", "SUNNY JAT (3022)", "SHIVANG SHARMA (2998)",
    "RAAVI SIMAVAT (2910)", "PURAV SHARMA (2963)", "PRABASH DEWAN (3438)", "NIMIT CHOUDHARY (3163)",
    "NAVYANSH YADAV (3024)", "MANNAT SHARMA (2995)", "LOVELY SINGH (3186)", "KHUSHMITA CHOUDHARY (2992)",
    "JAYANT SHARMA (3199)", "GATIK SHARMA (2938)", "APSA CHOUDHARY (2990)", "ADITI (3024)"
  ];

  const handleSelectAll = () => {
    if (selectAll) {
      setSelectedStudents([]);
    } else {
      setSelectedStudents([...students]);
    }
    setSelectAll(!selectAll);
  };

  const handleStudentToggle = (student) => {
    if (selectedStudents.includes(student)) {
      setSelectedStudents(selectedStudents.filter((s) => s !== student));
    } else {
      setSelectedStudents([...selectedStudents, student]);
    }
  };

  return (
    <>
      <div className="layout-wrapper layout-content-navbar">
        <div className="layout-container">
          <Header />
          <div className="layout-page">
            <Nav />
            <div className="content-wrapper">
              <div className="container-fluid py-4">
                <div className="card shadow-sm p-4">
                  <div className="row align-items-center mb-3">
                    <div className="col-md-12 col-12 mb-5 d-flex justify-content-between">
                      <h4 className="mb-0 text-primary">Fill Details</h4>
                      <button className="btn btn-outline-danger " onClick={() => navigate(-1)}>
                      <i className="bi bi-arrow-left-circle me-1"></i>
                        Back
                      </button>
                    </div>
                    <div className="col-md-6 col-12 text-md-end text-start">
                   
                    </div>
                  </div>

                  {/* Kit Distribution Form Starts */}
                  <div className="row mb-3">
                    <div className="col-md-6 mb-2 form-floating form-floating-outline">
                      <select className="form-select">
                        <option>Select Batch</option>
                        <option>B.</option>
                        <option>C.</option>
                      </select>
                      <label className="ms-5">Batch Name</label>
                    </div>
                    <div className="col-md-6 mb-2 form-floating form-floating-outline">
                      <input type="text" className="form-control" value="32" readOnly />
                      <label className="ms-5">Total Students</label>
                    </div>
                  </div>

                  <div className="mb-3">
                    <label className="form-label fw-bold text-primary">Students Details :</label>
                    <div className="form-check mb-2">
                      <input
                        className="form-check-input"
                        type="checkbox"
                        checked={selectAll}
                        onChange={handleSelectAll}
                      />
                      <label className="form-check-label badge bg-label-primary">All Select</label>
                    </div>
                    <div className="d-flex flex-wrap gap-3">
                      {students.map((student, index) => (
                        <div key={index} className="form-check">
                          <input
                            className="form-check-input"
                            type="checkbox"
                            checked={selectedStudents.includes(student)}
                            onChange={() => handleStudentToggle(student)}
                          />
                          <label className="form-check-label badge bg-label-primary">{student}</label>
                        </div>
                      ))}
                    </div>
                  </div>

                  <div className="border-top pt-3 mt-4">
                    <h5 className="fw-bold mb-3">Kit Details :</h5>
                    <div className="row">
                      <div className="col-md-6 mb-3 form-floating form-floating-outline">
                        <select className="form-select">
                          <option>Select Kit</option>
                          <option>Kit A</option>
                          <option>Kit B</option>
                        </select>
                        <label className="ms-5">Kit Name</label>
                      </div>
                      <div className="col-md-6 mb-3 form-floating form-floating-outline">
                        <input type="number" className="form-control" defaultValue={1} />
                        <label className="ms-5">Quantity</label>
                      </div>
                      <div className="col-12 mb-3 form-floating form-floating-outline">
                        <textarea className="form-control input-uppercase" rows="2" placeholder="Enter any remark"></textarea>
                        <label className="ms-5">Remark</label>
                      </div>
                    </div>
                  </div>
                  <div className="col-md-12 text-end">

                  <button className="btn btn-primary mx-2">Submit</button>
                    
                  </div>

                  {/* Kit Distribution Form Ends */}
                </div>
              </div>
              <Footer />
              <div className="content-backdrop fade"></div>
            </div>
          </div>
        </div>
        <div className="layout-overlay layout-menu-toggle"></div>
        <div className="drag-target"></div>
      </div>
    </>
  );
};

export default AllBatchkittransction;
